import React from "react";
import { Space as AntdSpace } from "antd";
import type { SpaceProps as AntdSpaceProps } from "antd";

export type SpaceProps = AntdSpaceProps;

type SpaceComponent = React.FC<SpaceProps> & {
  Compact: typeof AntdSpace.Compact;
};

/**
 * Space component - provides consistent spacing between child elements
 * Preserves Ant Design static subcomponents (e.g., Space.Compact)
 */
const Space: SpaceComponent = (props) => {
  return <AntdSpace {...props} />;
};

Space.Compact = AntdSpace.Compact;

export default Space;
